module.exports = {"pathContext":{"name":"OrderItemEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"OrderItem","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-order-item-edge.json
// module id = 1885
// module chunks = 280388727095966